// src/components/Footer.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../styles/Footer.module.css';

const Footer = () => {
  // 使用 i18n 的翻译钩子
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.footerGrid}>
          <div>
            <a href="#" className={styles.footerLogo}>
              <img
                src={`${process.env.PUBLIC_URL}/images/logo.jpg`}
                alt="Logo"
                className={styles.logoImage}
              />
              {t('footer.brandName')}
            </a>

            {/* 公司信息 - 固定显示英文 */}
            <div className={styles.companyInfo}>
              <h4 className={styles.companyTitle}>SMARTTOOL AI SOLUTIONS LIMITED</h4>
              <p className={styles.companyAddress}>Room 502C, 5/F, Ho King Commercial Centre, 2-16 Fa Yuen Street, Mong Kok, Hong Kong</p>
            </div>

            {/* <div className={styles.socialLinks}>
              <a href="#" className={styles.socialLink}><i className="fab fa-twitter"></i></a>
              <a href="#" className={styles.socialLink}><i className="fab fa-github"></i></a>
              <a href="#" className={styles.socialLink}><i className="fab fa-linkedin"></i></a>
              <a href="#" className={styles.socialLink}><i className="fas fa-envelope"></i></a>
            </div> */}
          </div>
          
          {/* <div>
            <h3 className={styles.footerTitle}>{t('footer.about.title')}</h3>
            <div className={styles.footerLinks}>
              <a href="#" className={styles.footerLink}>{t('footer.about.features')}</a>
              <a href="#" className={styles.footerLink}>{t('footer.about.showcase')}</a>
              <a href="#" className={styles.footerLink}>{t('footer.about.contact')}</a>
            </div>
          </div>
          <div>
            <h3 className={styles.footerTitle}>{t('footer.resources.title')}</h3>
            <div className={styles.footerLinks}>
              <a href="#" className={styles.footerLink}>{t('footer.resources.docs')}</a>
              <a href="#" className={styles.footerLink}>{t('footer.resources.support')}</a>
              <a href="#" className={styles.footerLink}>{t('footer.resources.faq')}</a>
            </div>
          </div>
          <div>
            <h3 className={styles.footerTitle}>{t('footer.links.title')}</h3>
            <div className={styles.footerLinks}>
              <a href="#" className={styles.footerLink}>THINKAny</a>
              <a href="#" className={styles.footerLink}>HeyBeauty</a>
              <a href="#" className={styles.footerLink}>Pagen</a>
            </div>
          </div> */}
        </div>
        <div className={styles.footerBottom}>
          <p className={styles.copyright}>{t('footer.copyright')}</p>
          {/* <div className={styles.footerBottomLinks}>
            <a href="#" className={styles.footerBottomLink}>{t('footer.privacy')}</a>
            <a href="#" className={styles.footerBottomLink}>{t('footer.terms')}</a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;